/**
 * Pre-orders on the storefront (snippets/habitat-preorder.liquid; habitat-books DECISIONS §40).
 *
 * Every part of a pre-order the server renders is marked [data-hh-preorder]: the stock line ("status") and,
 * inside the product form, the line item property with its note ("form"). This keeps them in step:
 * - a variant change: each part takes its new HTML from the section Shopify rendered for that variant (the
 *   same event Dwell's own blocks follow), so the property never belongs to the variant before;
 * - a quantity change: the property is sent only for the units the shelf does not cover, and when the
 *   quantity is more than the shelf holds it reads (and the note shows) "2 ship now, 1 from about 1 February".
 * Without this script the server's version stands, which is right for one unit.
 */

const PART = '[data-hh-preorder]';
const FORM_PART = '[data-hh-preorder="form"]';

/** @param {Element} part */
function quantityOf(part) {
  const form = part.closest('form');
  if (!form) return 1;
  /** @type {HTMLInputElement | null} */
  const input =
    form.querySelector('input[name="quantity"]') ||
    (form.id ? document.querySelector(`input[name="quantity"][form="${CSS.escape(form.id)}"]`) : null);
  const n = Number.parseInt(input?.value ?? '1', 10);
  return Number.isFinite(n) && n > 0 ? n : 1;
}

/** @param {Element} part */
function sync(part) {
  if (!(part instanceof HTMLElement) || part.dataset.shelf === undefined) return;
  /** @type {HTMLInputElement | null} */
  const input = part.querySelector('input[type="hidden"]');
  /** @type {HTMLElement | null} */
  const note = part.querySelector('.hh-preorder-form__note');
  if (!input) return;
  const shelf = Number.parseInt(part.dataset.shelf, 10) || 0;
  const quantity = quantityOf(part);
  if (quantity <= shelf) {
    input.disabled = true;
    if (note) note.hidden = true;
    return;
  }
  input.disabled = false;
  if (shelf > 0) {
    const text = (part.dataset.split || '').replace('[now]', String(shelf)).replace('[later]', String(quantity - shelf));
    input.value = text;
    if (note) {
      note.textContent = text;
      note.hidden = false;
    }
  } else {
    input.value = part.dataset.all || input.value;
    if (note) note.hidden = true;
  }
}

/** @param {ParentNode} root */
function syncAll(root) {
  for (const part of root.querySelectorAll(FORM_PART)) sync(part);
}

document.addEventListener('shopify:product:select', (event) => {
  const target = event.target;
  if (!(target instanceof Element) || target.closest('product-card')) return;
  const scope = target.closest('.shopify-section, dialog') || document;
  /** @type {Promise<any> | undefined} */
  const pending = /** @type {any} */ (event).promise;
  pending
    ?.then((result) => {
      const html = result?.detail?.html;
      if (!html || typeof html.querySelector !== 'function') return;
      for (const part of scope.querySelectorAll(PART)) {
        if (!(part instanceof HTMLElement)) continue;
        const fresh = html.querySelector(`[data-hh-preorder="${part.dataset.hhPreorder}"]`);
        if (fresh) part.replaceWith(document.importNode(fresh, true));
      }
      syncAll(scope);
    })
    .catch(() => {});
});

for (const type of ['quantity-selector:update', 'change', 'input']) {
  document.addEventListener(type, (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const form = target.closest('form') || (target instanceof HTMLInputElement ? target.form : null);
    if (form) syncAll(form);
  });
}

syncAll(document);
